import { TFieldItemType } from '@interfaces/assets/assetHistory';
import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EProfileFields = {
	id: 'id',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	assetId: 'assetId',
	lat: 'lat',
	lng: 'lng',
	northing: 'northing',
	easting: 'easting',
	height: 'height',
	adPropertyNoName: 'adPropertyNoName',
	adStreetName: 'adStreetName',
	adLocality: 'adLocality',
	adTownCity: 'adTownCity',
	adPostCode: 'adPostCode',
	uprn: 'uprn',
	isAvailable: 'isAvailable',
	assetAccessDetails: 'assetAccessDetails',
	assetAccessDetailsFile: 'assetAccessDetailsFile',
	contactPerson: 'contactPerson',
	powerSupplyAvailabilityStatus: 'powerSupplyAvailabilityStatus',
	powerSupplyAvailabilityDetails: 'powerSupplyAvailabilityDetails',
	powerSupplyAvailabilityDetailsFiles: 'powerSupplyAvailabilityDetailsFiles',
	backhaulAccessibilityStatus: 'backhaulAccessibilityStatus',
	backhaulAccessibilityDetails: 'backhaulAccessibilityDetails',
	backhaulAccessibilityDetailsFiles: 'backhaulAccessibilityDetailsFiles',
	assetSiteAvailabilityStatus: 'assetSiteAvailabilityStatus',
	assetSiteAvailabilityDetails: 'assetSiteAvailabilityDetails',
	assetSiteAvailabilityDetailsFile: 'assetSiteAvailabilityDetailsFile',
	siteAvailabilityReviewDate: 'siteAvailabilityReviewDate',
	specialImplementationIssuesExist: 'specialImplementationIssuesExist',
	specialImplementationIssueDetails: 'specialImplementationIssueDetails',
	specialImplementationIssueDetailsFile: 'specialImplementationIssueDetailsFile',
	reference2AssetOwner: 'reference2AssetOwner',
	reference2AssetOwnerContactUsers: 'reference2AssetOwnerContactUsers',
	indicativeAcceptablePricing: 'indicativeAcceptablePricing',
	lastRecordUpdate: 'lastRecordUpdate',
	lastVerificationDate: 'lastVerificationDate',
	assetType: 'assetType',
	assetSubType: 'assetSubType',
	maxOperators: 'maxOperators',
	locationDescription: 'locationDescription',
	assetOwnerNotes: 'assetOwnerNotes',
	responsible: 'responsible',
	startDate: 'startDate',
	endDate: 'endDate',
	isHidden: 'isHidden',
	creator: 'creator',
	owner: 'owner',
	count: 'count',
	markerType: 'markerType',
	ngr: 'ngr',
	name: 'name',
	title: 'title',
	showOnMap: 'showOnMap',
	backhaulAccessibilityDetailsFileIds: 'backhaulAccessibilityDetailsFileIds',
	assetSiteAvailabilityDetailsFileIds: 'assetSiteAvailabilityDetailsFileIds',
	powerSupplyAvailabilityDetailsFileIds: 'powerSupplyAvailabilityDetailsFileIds',
	specialImplementationIssueDetailsFileIds: 'specialImplementationIssueDetailsFileIds',
	assetAccessDetailsFileIds: 'assetAccessDetailsFileIds',
} as const;

export type TProfileFields = TValueOfStringRecord<typeof EProfileFields>

export const nameSectionFields: TFieldItemType[] = [
	{
		className: 'name',
		fieldName: EProfileFields.assetId,
		prefix: 'Asset ',
	},
	{
		className: 'type',
		fieldName: [EProfileFields.assetType, EProfileFields.title],
	},
	{
		className: 'subtype',
		fieldName: [EProfileFields.assetSubType, EProfileFields.title],
	},
];

export const dateDescriptionFields: TFieldItemType[] = [
	{
		fieldName: EProfileFields.lastVerificationDate,
		fieldTitle: 'Last verification update:',
	},
	{
		fieldName: EProfileFields.siteAvailabilityReviewDate,
		fieldTitle: 'Site availability review:',
	},
];

export const FIRST_VERSION = 1;
